import {FC} from 'react'

import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {routeTo} from '@/utils/router'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {TramaLogo} from '../../common/icons/TramaLogo'

type HeaderLogoProps = {
  size?: 'medium' | 'small'
  linkHref?: string
}

export const HeaderLogo: FC<HeaderLogoProps> = ({size, linkHref}) => (
  <>
    <div className="logo">
      <Link href={linkHref || routeTo.home()}>
        <TramaLogo size={size} variant="white" />
      </Link>
    </div>

    <style jsx>{`
      .logo {
        display: flex;
        margin-left: ${theme.spacing[1.5]};
      }
      @media ${TABLET_SCREENSIZE} {
        .logo {
          margin-left: 0;
        }
      }
    `}</style>
  </>
)
